export default __webpack_public_path__ + "static/forevery-9f606ee4f7a28b158c028166779c080a.jpg";